import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=9188e874&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=9188e874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9188e874",
  null
  
)

export default component.exports